<template>
    <div class="btn">
        <el-button 
            v-if="frompage == 'default'"
            class="text-button"
            :class="bgcolor"
            :disabled="!!display" 
            @click="handleClick" 
            v-html="btn_text"
        />
        <el-button 
            v-if="frompage == 'menudetail'" 
            class="text-button"
            :class="bgcolor" 
            :disabled="!!display" 
            :loading="loading" 
            @click="handleClick"
        >
            {{ btn_text }}
        </el-button>
        <div v-if="frompage == 'cart'">
            <el-row
                v-if="(display)"
                :class="(!!display) ? 'fs-disable fs-btn-cart' : 'fs-confirm fs-btn-cart'"
            >
                <el-col :span="5" class="text-left">
                    <el-badge 
											:value="badge" 
											type="primary" 
											:class="(!!display) ? 'fs-bg-disable' : 'fs-bg-defualt'"
										>
											<img 
												width="20" 
												height="20" 
												:src="(!!display) ? require('@/assets/icons/disable-basket.png') : require('@/assets/icons/basket.png')" 
											/>
                    </el-badge>
                </el-col>
                <el-col :span="14" class="text-center">
                    <label class="text-button">{{ btn_text }}</label>
                </el-col>
                <el-col :span="5" class="text-right text-button">
                    <b>{{ totalprice | priceFormat(roundingType,$store.getters.currency) }}</b>
                </el-col>
            </el-row>
            <el-row
                v-else
                :class="(!!display) ? 'fs-disable fs-btn-cart' : 'fs-confirm fs-btn-cart'"
                @click.native="handleClick"
            >
                <el-col :span="7" class="text-left">
                    <el-badge :value="badge" type="primary" v-bind:class="(!!display) ? 'fs-bg-disable' : 'fs-bg-defualt'">
                        <img width="20" height="20" :src="(!!display) ? require('@/assets/icons/disable-basket.png') : require('@/assets/icons/basket.png')" />
                    </el-badge>
                </el-col>
                <el-col :span="10" class="text-center">
                    <label class="text-button">{{ btn_text }}</label>
                </el-col>
                <el-col :span="7" class="text-right text-button">
                    <b>{{ totalprice | priceFormat(roundingType,$store.getters.currency) }}</b>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import Mixins from '@/utils/mixins'

export default {
    mixins: [Mixins],
	props: {
        display:{
            default: false
        },
        btn_text:{
            default: '-'
        },
        handleClick:{
            type: Function,
            default: () => {}
        },
        bgcolor: {
            default: 'fs-bg-link'
        },
        loading: {
            default: true
        },
        frompage: {
            default: 'default'
        },
        badge: {
            default: 0
        },
        totalprice: {
            default: 0
        }
    },
    computed: {
        roundingType () {
            return this.$store.getters.roundingType
        }
    }
}
</script>
<style scoped>
    .el-button{
        height: 44px;
        border-radius: 10px;
        width: calc(100% - 20px);
        font-weight: 400;
        font-size: 16px;
        background: #28B7FF;
        border: 0px solid #28B7FF;
        color: #fff;
    }
    .btn{
        width: 100%;
        text-align: center;
        padding: 0 0 20px 0;
    }
    .el-button:disabled {
        height: 44px;
        border-radius: 10px;
        /* width: calc(100% - 20px) !important; */
        background: #E0E0E0 !important;
        border: 0px solid #E0E0E0 !important;
        color: #9E9E9E !important;
    }
    .el-button:focus, .el-button:hover {
        background: #28B7FF;
        border: 0px solid #28B7FF;
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/element/fullButton.vue